// 🔐 accounts (09-30): open the sign-in sheet or show the account toast from
// anywhere (the bugReport.js pattern: one app-level layer, AccountLayer,
// mounted in App.js, listens for these).
export const SIGNIN_EVENT = 'myspaice-open-sign-in';
export const ACCOUNT_TOAST_EVENT = 'myspaice-account-toast';

export function openSignIn(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SIGNIN_EVENT, { detail }));
}

export function showAccountToast(text) {
  if (typeof window === 'undefined' || !text) return;
  window.dispatchEvent(new CustomEvent(ACCOUNT_TOAST_EVENT, { detail: { text: String(text) } }));
}
